import { api } from "../api";


const BASE_URL = "/web-user/employees";

export const getEmployeeByNumber = (number) => {
  return api.get(`${BASE_URL}/${number}`);
};
